// Vite HMR support
if (import.meta.hot) {
  import.meta.hot.accept();
}

const voiceSplide = document.querySelector('.p-voice .splide');
// console.log(voiceSplide);

import Splide from '@splidejs/splide';
// 必ずCSSもインポートしてください
import '@splidejs/splide/css';
if (voiceSplide) {
  new Splide(voiceSplide, {
    type: 'loop',
    perPage: 3,
    focus: 'center',
    updateOnMove: true,
    gap: '1.5rem',
    trimSpace: false,
    pagination: true,
    reducedMotion: {
      speed: 0,
      rewindSpeed: 0,
    },
    breakpoints: {
      1024: {
        perPage: 2,
        focus: 'number',
      },
      768: {
        perPage: 1,
        focus: 'number',
      },
      640: {
        perPage: 1,
        focus: 'number',
      },
    },
  }).mount();
}

// TOPピックアップ案件：スマホ幅だけスライダー（表示タブでのみ mount）
const pickupSplideMobileOptions = {
  type: 'loop',
  perPage: 1,
  gap: '1rem',
  autoplay: true,
  interval: 3000,
  pauseOnHover: false,
  pauseOnFocus: false,
  pagination: true,
  arrows: false,
  updateOnMove: true,
};

const isPickupMobile = () => window.matchMedia('(max-width: 767px)').matches;

const destroyPickupSplide = (el) => {
  if (el.splide) {
    el.splide.destroy(true);
  }
};

const stopPickupSplides = (panel) => {
  panel.querySelectorAll('.js-pickup-splide').forEach((el) => {
    if (!el.splide) return;
    // 非表示にする瞬間に先頭へ戻してから破棄
    el.splide.go(0);
    destroyPickupSplide(el);
  });
};

const startPickupSplides = (panel) => {
  if (!isPickupMobile()) return;

  panel.querySelectorAll('.js-pickup-splide').forEach((el) => {
    destroyPickupSplide(el);
    const splide = new Splide(el, pickupSplideMobileOptions).mount();
    splide.go(0);
  });
};

import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
  offset: 120,
  duration: 400,
  easing: 'ease-out',
});

// document.addEventListener('DOMContentLoaded', () => {
//   const toggleBtn = document.querySelector('.js-dropdown-toggle');
//   const accordionTriggers = document.querySelectorAll('.js-accordion-trigger');
//   const prefContainer = document.querySelector('.js-pref-container');

//   // 1. 都道府県の自動生成
//   const prefectures = [
//     '北海道',
//     '青森県',
//     '岩手県',
//     '宮城県',
//     '秋田県',
//     '山形県',
//     '福島県',
//     '茨城県',
//     '栃木県',
//     '群馬県',
//     '埼玉県',
//     '千葉県',
//     '東京都',
//     '神奈川県',
//     '新潟県',
//     '富山県',
//     '石川県',
//     '福井県',
//     '山梨県',
//     '長野県',
//     '岐阜県',
//     '静岡県',
//     '愛知県',
//     '三重県',
//     '滋賀県',
//     '京都府',
//     '大阪府',
//     '兵庫県',
//     '奈良県',
//     '和歌山県',
//     '鳥取県',
//     '島根県',
//     '岡山県',
//     '広島県',
//     '山口県',
//     '徳島県',
//     '香川県',
//     '愛媛県',
//     '高知県',
//     '福岡県',
//     '佐賀県',
//     '長崎県',
//     '熊本県',
//     '大分県',
//     '宮崎県',
//     '鹿児島県',
//     '沖縄県',
//   ];

//   if (prefContainer) {
//     const fragment = document.createDocumentFragment();
//     prefectures.forEach((pref, index) => {
//       const label = document.createElement('label');
//       label.innerHTML = `<input type="checkbox" name="pref" value="${index + 1}"> ${pref}`;
//       fragment.appendChild(label);
//     });
//     prefContainer.appendChild(fragment);
//   }

//   // 2. 絞り込み検索ボタンのイベント（必要に応じて検索実行処理などをここに記述）
//   if (toggleBtn) {
//     toggleBtn.addEventListener('click', (e) => {
//       e.stopPropagation();
//       // 他の開いているフィルターをすべて閉じてから検索処理へ
//       closeAllFilters();
//       console.log('検索を実行します');
//     });
//   }

//   // 3. 各グループのトリガークリック処理（排他制御を追加）
//   accordionTriggers.forEach((trigger) => {
//     trigger.addEventListener('click', (e) => {
//       e.stopPropagation();

//       const targetContent = trigger.nextElementSibling;
//       const isAlreadyOpen = targetContent && targetContent.classList.contains('is-open');

//       // ★ 修正点: クリックされたもの「以外」のフィルターをすべてリセットして閉じる
//       closeAllFilters();

//       // クリックされたフィルターが元々閉じていた場合のみ、新しく開く
//       if (!isAlreadyOpen && targetContent && targetContent.classList.contains('c-filter-group__content')) {
//         trigger.classList.add('is-active');
//         targetContent.classList.add('is-open');
//       }
//     });
//   });

//   // 4. メニューの外側（画面のどこか）をクリックしたら、開いているフィルターをすべて閉じる
//   document.addEventListener('click', () => {
//     closeAllFilters();
//   });

//   // 全てのフィルターを一括で閉じる共通関数
//   function closeAllFilters() {
//     // コンテンツを閉じる
//     document.querySelectorAll('.c-filter-group__content').forEach((el) => {
//       el.classList.remove('is-open');
//     });
//     // ボタンの矢印などのアクティブ状態を解除
//     accordionTriggers.forEach((btn) => {
//       btn.classList.remove('is-active');
//     });
//   }
// });

document.addEventListener('DOMContentLoaded', () => {
  // 1. 必要な要素をすべて取得
  const tabButtons = document.querySelectorAll('.p-pickup--btns .p-pickup-btn');
  const tabPanels = document.querySelectorAll('.p-pickup--container .p-pickup__panel');

  // 要素が存在しない場合は処理をスキップ（エラー防止）
  if (tabButtons.length === 0 || tabPanels.length === 0) return;

  const activatePickupPanel = (panel) => {
    // 非表示だったカードの AOS を即時表示（opacity:0 のまま Splide が壊れないように）
    panel.querySelectorAll('[data-aos]').forEach((node) => {
      node.classList.add('aos-animate');
    });

    // レイアウト確定後に Splide を mount（display:none 解除後の幅で初期化）
    requestAnimationFrame(() => {
      startPickupSplides(panel);
      if (typeof AOS !== 'undefined' && AOS.refresh) {
        AOS.refresh();
      }
    });
  };

  // 初期表示タブだけスライダー起動
  const initialPanel = document.querySelector('.p-pickup__panel.is-active');
  if (initialPanel) {
    activatePickupPanel(initialPanel);
  }

  // 画面幅切替時：モバイルなら表示タブを mount、PC なら全破棄
  const pickupMq = window.matchMedia('(max-width: 767px)');
  const onPickupMqChange = (e) => {
    if (e.matches) {
      const active = document.querySelector('.p-pickup__panel.is-active');
      if (active) {
        activatePickupPanel(active);
      }
    } else {
      document.querySelectorAll('.js-pickup-splide').forEach(destroyPickupSplide);
    }
  };
  if (pickupMq.addEventListener) {
    pickupMq.addEventListener('change', onPickupMqChange);
  } else if (pickupMq.addListener) {
    pickupMq.addListener(onPickupMqChange);
  }

  // 2. すべてのボタンにクリックイベントを設定
  tabButtons.forEach((buttonWrapper) => {
    const button = buttonWrapper.querySelector('button');
    if (!button) return;

    button.addEventListener('click', () => {
      // クリックされたボタンの data-tab の値（例: "tab-1"）を取得
      const targetTab = button.getAttribute('data-tab');
      // 対応するパネルのID（例: "panel-tab-1"）を生成
      const targetPanelId = `panel-tab-${targetTab.split('-')[1]}`;
      const targetPanel = document.getElementById(targetPanelId);

      // 3. 一旦すべてのボタンとパネルからアクティブクラスを消す
      tabButtons.forEach((btn) => btn.classList.remove('is-active'));
      tabPanels.forEach((panel) => {
        // 表示中だったタブは非表示にする瞬間に先頭へ戻して破棄
        if (panel.classList.contains('is-active') && panel !== targetPanel) {
          stopPickupSplides(panel);
        }
        panel.classList.remove('is-active');
      });

      // 4. クリックされたボタン（の親要素）にアクティブクラスを付与
      buttonWrapper.classList.add('p-pickup-btn', 'is-active');

      // 5. 表示タブで Splide を新規 mount して開始
      if (targetPanel) {
        targetPanel.classList.add('is-active');
        activatePickupPanel(targetPanel);
      }
    });
  });
});

// const hoge = "hogehoge"
// console.log(hoge)

// console.log("最初");

// // お約束を取り付けたい処理にPromise
// new Promise((resolve) => {
//   //1秒後に実行する処理
//   setTimeout(() => {
//     console.log("2番目(1秒後に実行)");
//     //無事処理が終わったことを伝える
//     resolve();
//   }, 1000);
// }).then(() => {
//   // 処理が無事終わったことを受けとって実行される処理
//   console.log("3番目");
// });

// // 約一秒後、受け取った値を2倍で返す非同期関数
// const promiseFunc = value => {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       resolve(value * 2);
//     }, 1000);
//   });
// };

// // 非同期関数
// async function asyncFunc() {
//   // await 式によって順番に処理される
//   const a = await promiseFunc(1);
//   const b = await promiseFunc(2);
//   const c = await promiseFunc(33);

//   return a + b + c;
// }

// asyncFunc().then(value => {
//   console.log(value); // => 12
// });

// import Vue from 'vue'
// import Vue from 'vue/dist/vue.esm.js';
// import axios from 'axios'
// // import Inview from 'in-view'
import objectFitImages from 'object-fit-images';
// require('intersection-observer');

//object fit
objectFitImages('.cover img', { watchMQ: true });

// import Splide from '@splidejs/splide';
// new Splide( '.splide', {
//   type   : 'loop',
//   // perPage: 3,
// } ).mount();

// sticky header
function scrollFunction() {
  const this_y = window.pageYOffset || window.scrollY;
  const header = document.getElementById('header');
  const subContents = document.querySelector('.p-main-contents-sub');
  // console.log(header.clientHeight);

  if (this_y > header.clientHeight) {
    if (header) {
      header.classList.add('active');
      setTimeout(() => {
        header.classList.add('in-view');
      }, 1000);
    }

    // if (subContents) {
    //   subContents.style.top = '98px';
    // }
  } else {
    if (header) {
      header.classList.remove('active', 'in-view');
    }

    // if (subContents) {
    //   subContents.style.top = '100px';
    // }
  }
}
window.onload = function () {
  scrollFunction();
};
window.onscroll = function () {
  scrollFunction();
};

// Nav
if (document.getElementsByClassName('globalNav')[0]) {
  const wrap = document.querySelector('.menu__btnwrap');
  const nav_el = document.querySelector('.spmenu_btn');
  const nav_state_class = 'globalNav_state';
  const nav_target_class = '.globalNav';
  const nav_close_class = 'spmenu_btnClose';
  const nav_wrap = document.querySelector('.menu');

  wrap.addEventListener(
    'click',
    () => {
      if (document.querySelector('.' + nav_state_class) === null) {
        document.querySelector(nav_target_class).classList.add(nav_state_class);
        nav_el.classList.add(nav_close_class);
      } else {
        document.querySelector(nav_target_class).classList.remove(nav_state_class);
        nav_el.classList.remove(nav_close_class);
      }
    },
    false
  );

  nav_wrap.addEventListener(
    'click',
    () => {
      document.querySelector(nav_target_class).classList.remove(nav_state_class);
      nav_el.classList.remove(nav_close_class);
    },
    false
  );
}

// accordion
var trigger = document.querySelectorAll('.accordion__title');
for (var i = 0; i < trigger.length; i++) {
  trigger[i].addEventListener('click', function () {
    var body = this.nextElementSibling;
    if (this.classList.contains('is-active')) {
      this.classList.remove('is-active');
      body.classList.remove('is-open');
    } else {
      this.classList.add('is-active');
      body.classList.add('is-open');
    }
  });
}

// 外部リンク別窓
var external_link__add_blank = function () {
  var a_tags = document.querySelectorAll('a:not([target="_blank"])'),
    res = [];
  if (!a_tags.length) return; // a_tagsがマッチなし = end
  for (var i = 0; i < a_tags.length; i++) {
    if (a_tags[i].href.indexOf(window.location.host) !== -1) continue;
    if (a_tags[i].classList.contains('none')) continue;
    if (a_tags[i].classList.contains('sbi_load_btn')) continue;
    // if (a_tags[i].classList.contains('none')) continue;
    // console.log(a_tags[i].href)
    if (a_tags[i].href.indexOf('#') === 1) continue;
    a_tags[i].setAttribute('target', '_blank');
    res.push(a_tags[i]);
  }
  return res;
};
// var a__add_blanks = external_link__add_blank(); console.log(a__add_blanks);
document.addEventListener('DOMContentLoaded', external_link__add_blank, false);

// 要素が画面内に入ったかどうか
// 対象要素の監視を開始する関数
function observeElement(element) {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        // 一度だけ発火して安定させる
        entry.target.classList.add('is-animated');
        obs.unobserve(entry.target);
      });
    },
    {
      threshold: 0.2,
      rootMargin: '0px 0px -8% 0px',
    }
  );

  observer.observe(element);
}

// 監視したい要素を取得
const targetElement = document.querySelectorAll('.target');
targetElement.forEach((el) => {
  observeElement(el);
});

/*******************
  table スクロール
*******************/
import ScrollHint from 'scroll-hint';
new ScrollHint('.scroll-table', {
  scrollHintIconAppendClass: 'scroll-hint-icon-black', // white-icon will appear
  i18n: {
    scrollable: 'スクロールできます',
  },
});

document.addEventListener('DOMContentLoaded', () => {
  // ==========================================
  // 1. 絞り込みモーダルの開閉制御
  // ==========================================
  const filterModal = document.getElementById('js-filter-modal');
  const filterModalOpeners = document.querySelectorAll('.js-filter-modal-open');
  const filterModalClosers = document.querySelectorAll('.js-filter-modal-close');

  const openFilterModal = () => {
    if (!filterModal) return;
    filterModal.classList.add('is-open');
    filterModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-filter-modal-open');
  };

  const closeFilterModal = () => {
    if (!filterModal) return;
    filterModal.classList.remove('is-open');
    filterModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-filter-modal-open');
  };

  filterModalOpeners.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openFilterModal();
    });
  });

  filterModalClosers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeFilterModal();
    });
  });

  // モーダル外側（オーバーレイ含む）クリックで閉じる
  if (filterModal) {
    filterModal.addEventListener('click', (e) => {
      if (!e.target.closest('.c-filter-modal__dialog')) {
        closeFilterModal();
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterModal && filterModal.classList.contains('is-open')) {
      closeFilterModal();
    }
  });

  // ==========================================
  // 2. リアルタイム件数取得（Ajax/Fetch）処理
  // ==========================================
  const form = document.getElementById('js-search-form');
  const countTarget = document.getElementById('js-search-count');
  const submitBtn = document.getElementById('js-search-submit');

  if (form && countTarget && submitBtn) {
    let abortController = null; // 前の通信をキャンセルするためのコントローラー
    let timer = null; // テキスト入力のデバウンスタイマー
    const salaryMinSelect = document.getElementById('js-filter-salary-min');
    const salaryMaxSelect = document.getElementById('js-filter-salary-max');

    // 下限 > 上限 なら上限をクリア（下限のみの検索にする）
    const normalizeSalarySelects = () => {
      if (!salaryMinSelect || !salaryMaxSelect) return;
      const minVal = salaryMinSelect.value;
      const maxVal = salaryMaxSelect.value;
      if (minVal !== '' && maxVal !== '' && Number(minVal) > Number(maxVal)) {
        salaryMaxSelect.value = '';
      }
    };

    // 空の入力は送らない（上限未指定を確実に「無し」として扱う）
    const buildSearchFormData = () => {
      normalizeSalarySelects();
      const formData = new FormData(form);
      for (const [key, value] of [...formData.entries()]) {
        if (value === '') {
          formData.delete(key);
        }
      }
      return formData;
    };

    // 件数を取得して更新する関数（loadingEl を指定したときだけその要素を薄くする）
    const updateSearchCount = (loadingEl = null) => {
      const formData = buildSearchFormData();
      // WordPressのAjaxに命令を届けるアクション名を追加
      formData.append('action', 'get_project_count');

      // すでに走っている通信があればキャンセルする（サーバー負荷軽減）
      if (abortController) {
        abortController.abort();
      }
      // 新しい通信のためのコントローラーを作成
      abortController = new AbortController();

      if (loadingEl) {
        loadingEl.classList.add('is-loading');
        loadingEl.disabled = true;
      }

      // Fetch API で通信を実行
      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        body: formData,
        signal: abortController.signal,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((result) => {
          if (result.success && result.data && typeof result.data.count !== 'undefined') {
            // 取得した件数を反映
            countTarget.textContent = result.data.count;
          }
        })
        .catch((error) => {
          // キャンセル（abort）によるエラー以外の場合のみログ出力
          if (error.name !== 'AbortError') {
            console.error('Fetch error:', error);
          }
        })
        .finally(() => {
          if (loadingEl) {
            loadingEl.classList.remove('is-loading');
            loadingEl.disabled = false;
          }
        });
    };

    const scheduleCountUpdate = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        updateSearchCount();
      }, 300);
    };

    // --- イベントの監視 ---

    // A. セレクトの変更を監視
    form.addEventListener('change', (e) => {
      if (e.target && (e.target.tagName === 'SELECT' || e.target.type === 'checkbox')) {
        if (e.target === salaryMinSelect || e.target === salaryMaxSelect) {
          normalizeSalarySelects();
        }
        updateSearchCount();
      }
    });

    // B. テキスト入力のタイピング停止を監視（300msデバウンス）
    form.addEventListener('input', (e) => {
      if (e.target && (e.target.type === 'text' || e.target.type === 'search')) {
        scheduleCountUpdate();
      }
    });

    // 送信時：検索ボタンだけ薄くする／空項目を除外し、不正な上限をクリア
    form.addEventListener('submit', () => {
      submitBtn.classList.add('is-loading');
      normalizeSalarySelects();
      form.querySelectorAll('input, select').forEach((el) => {
        if (el.name && el.value === '') {
          el.disabled = true;
        }
      });
    });

    // 全てクリア：クリアボタンだけ薄くして件数を再取得
    const clearAllBtn = document.querySelector('.js-filter-clear-all');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', (e) => {
        e.preventDefault();
        form.querySelectorAll('input[type="text"], input[type="search"]').forEach((el) => {
          el.value = '';
        });
        form.querySelectorAll('select').forEach((el) => {
          el.value = '';
        });
        updateSearchCount(clearAllBtn);
      });
    }

    // 初期表示時も現在の条件で件数を合わせる
    updateSearchCount();
  }
});

/*******************
  modal ボタン
*******************/
// footerボタン用モーダル
// const modalBtns = document.querySelectorAll(".modal-toggle");
// modalBtns.forEach(function (btn) {
//   btn.onclick = function () {
//     var modal = btn.getAttribute('data-modal');
//     document.getElementById(modal).style.display = "block";
//   };
// });
// const closeBtns = document.querySelectorAll(".modal-close");
// closeBtns.forEach(function (btn) {
//   btn.onclick = function () {
//     var modal = btn.closest('.modal');
//     modal.style.display = "none";
//   };
// });

// window.onclick = function (event) {
//   if (event.target.className === "modal") {
//     event.target.style.display = "none";
//   }
// };

// /*******************
//   画像操作
// *******************/
// let screen = document.body.clientWidth;
// let container = document.querySelector('.container__min');
// // console.log(screen)
// // console.log(container)
// if(container){
//   const width = container.offsetWidth;
// }
// if(document.querySelectorAll('.overimg-right')){
//   let client_w = document.querySelectorAll('.overimg-right');
//   for (let node of client_w) {
//     node.style.marginRight = ((container - screen) / 2) + 'px';
//   }
//   // console.log(client_w)
//   // console.log(((container - screen) / 2) + 'px')
//   // client_w.style.marginRight = ((container - screen) / 2) + 'px';
//   // client_w.forEach{}
// }

// if(document.querySelectorAll('.overimg-left')){
//   let client_w = document.querySelectorAll('.overimg-left');
//   for (let node of client_w) {
//     node.style.marginLeft = ((container - screen) / 2) + 'px';
//   }
//   // console.log(((container - screen) / 2) + 'px')
//   // client_w.style.marginLeft = ((container - screen) / 2) + 'px';
// }

// /*******************
//   instagram
// *******************/
// if (document.getElementById('insta__saloncoco')) {
//   const postsInstance = new Vue({
//     el: "#insta__saloncoco",
//     data() {
//       return {
//         insta_url: 'https://graph.facebook.com/v12.0/',
//         instagram_business_id: '17841450062107536',
//         access_token: 'EAAJKs8lGM8cBAMcr0FSCjTFtKuLiZBr8qMUZAMt1ZB8v73DhPjUKGGp9OSF564DOyvTyhXNG4u7r80qTw0DFphFMY7GlyBxmewWndVZBPVOwofxXRHSCUCyx0KNZBWsF8amPyOcmxO2nF6dzZCFvOoKSKF6lEJYaUIEGED7nMyJeEv5gZCxvL6SioId4FrXGWYZD',
//         // target_user: 'cocoplus_1101',
//         target_user: 'salon.coco.0731',
//         // query = 'business_discovery.username(' + target_user + '){id,followers_count,media_count,ig_id,media{caption,media_url,media_type,like_count,comments_count,timestamp,id}}',
//         // query: 'name,media{caption,like_count,media_url,permalink,timestamp,username}',
//         queryFirst: 'business_discovery.username(',
//         queryLast: '){followers_count,media_count,media{caption,like_count,media_url,media_type,permalink,timestamp,username}}',
//         // query: 'business_discovery.username(kaori.y_studio){followers_count,media_count,media{caption,like_count,media_url,permalink,timestamp,username}}',
//         posts: [],
//       }
//     },
//     mounted() {
//       console.log(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//       axios(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//         .then((res) => {
//           this.posts = res.data.business_discovery.media.data
//           // 他人のアカウント
//           // console.log(res.data.business_discovery.media.data)
//           // 自分のアカウント
//           // console.log(res.data.media.data)
//         })
//         .catch(error => {
//           console.log("ERROR:: ", error.res.data);
//         });
//     },
//     computed: {
//       rePosts() {
//         return this.posts.slice(0, 4)
//       }
//     },
//   })
// }

// if (document.getElementById('insta__cocoplus')) {
//   const postsInstance = new Vue({
//     el: "#insta__cocoplus",
//     data() {
//       return {
//         insta_url: 'https://graph.facebook.com/v12.0/',
//         instagram_business_id: '17841450062107536',
//         access_token: 'EAAJKs8lGM8cBAMcr0FSCjTFtKuLiZBr8qMUZAMt1ZB8v73DhPjUKGGp9OSF564DOyvTyhXNG4u7r80qTw0DFphFMY7GlyBxmewWndVZBPVOwofxXRHSCUCyx0KNZBWsF8amPyOcmxO2nF6dzZCFvOoKSKF6lEJYaUIEGED7nMyJeEv5gZCxvL6SioId4FrXGWYZD',
//         target_user: 'cocoplus_1101',
//         // target_user: 'salon.coco.0731',
//         // query = 'business_discovery.username(' + target_user + '){id,followers_count,media_count,ig_id,media{caption,media_url,media_type,like_count,comments_count,timestamp,id}}',
//         // query: 'name,media{caption,like_count,media_url,permalink,timestamp,username}',
//         queryFirst: 'business_discovery.username(',
//         queryLast: '){followers_count,media_count,media{caption,like_count,media_url,media_type,permalink,timestamp,username}}',
//         // query: 'business_discovery.username(kaori.y_studio){followers_count,media_count,media{caption,like_count,media_url,permalink,timestamp,username}}',
//         posts: [],
//       }
//     },
//     mounted() {
//       console.log(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//       axios(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//         .then((res) => {
//           this.posts = res.data.business_discovery.media.data
//           // 他人のアカウント
//           // console.log(res.data.business_discovery.media.data)
//           // 自分のアカウント
//           // console.log(res.data.media.data)
//         })
//         .catch(error => {
//           console.log("ERROR:: ", error.res.data);
//         });
//     },
//     computed: {
//       rePosts() {
//         return this.posts.slice(0, 4)
//       }
//     },
//   })
// }

// /*******************
//   map
// *******************/
// // if (document.getElementById('Map')) {
// //   const mapInstance = new Vue({
// //     el: "#Map",
// //     data() {
// //       return {
// //         lat: 34.6704542,
// //         lng: 135.5013464,
// //         zoom: 16,
// //         icon: THEME_URL + "/assets/mappin.png",
// //         geometry: {
// //           hue: '#111',       // 色
// //           gamma: 0.1,        // ガンマ 0.01 ~ 10
// //           lightness: -70,    // 明度  -100 ~ 100
// //           saturation: -100,   // 彩度 -100 ~ 100
// //         },
// //         labels: {
// //           hue: '#ae9e74',       // 色
// //           gamma: 1,        // ガンマ
// //           lightness: 0,    // 明度
// //           saturation: -50, // 彩度
// //         }
// //       }
// //     },
// //     mounted() {
// //       let map
// //       let marker
// //       let center = {
// //         lat: Number(this.lat), // 緯度
// //         lng: Number(this.lng) // 経度
// //       }
// //       map = new google.maps.Map(document.getElementById('Map'), { // #sampleに地図を埋め込む
// //         center: center, // 地図の中心を指定
// //         zoom: this.zoom, // 地図のズームを指定
// //         disableDefaultUI: true,
// //         styles: [
// //           {
// //             featureType: 'all',
// //             elementType: 'geometry',
// //             stylers: [
// //               { hue: this.geometry.hue },
// //               { gamma: this.geometry.gamma },
// //               { lightness: this.geometry.lightness },
// //               { saturation: this.geometry.saturation },
// //             ],
// //           },
// //           {
// //             featureType: 'all',
// //             elementType: 'labels',
// //             stylers: [
// //               { hue: this.labels.hue },
// //               { gamma: this.labels.gamma },
// //               { lightness: this.labels.lightness },
// //               { saturation: this.labels.saturation },
// //             ],
// //           },
// //         ]
// //       })
// //       marker = new google.maps.Marker({ // マーカーの追加
// //         position: center, // マーカーを立てる位置を指定
// //         map: map, // マーカーを立てる地図を指定
// //         icon: this.icon // マーカーのアイコン指定
// //       })
// //     },
// //   })
// // }

// /*******************
//   posts
// *******************/

// // if (document.getElementById('Posts')) {
// //   const postsInstance = new Vue({
// //     el: "#Posts",
// //     data() {
// //       return {
// //         cats: [],
// //         posts: [],
// //         eventObject: '',
// //       }
// //     },
// //     mounted() {
// //       axios(BASEURL + 'posts')
// //         .then((res) => {
// //           this.posts = res.data
// //         })
// //       axios(BASEURL + 'categories')
// //         .then((res) => {
// //           this.cats = res.data.filter(item => item.slug != 'uncategorized')
// //         })
// //     },
// //     methods: {
// //       btnClicked(e) {
// //         axios(BASEURL + 'posts')
// //           .then((res) => {
// //             this.posts = res.data.filter(item => item.categories.includes(e))
// //           })
// //       }
// //     },
// //   })
// // }

// /*******************
//   posts
// *******************/

// // if (document.getElementById('Cat')) {
// //   const postsInstance = new Vue({
// //     el: "#Cat",
// //     data() {
// //       return {
// //         cats: [],
// //       }
// //     },
// //     mounted(){
// //       axios(BASEURL+'categories')
// //       .then( (res) =>{
// //         this.cats = res.data.filter(item => item.slug != 'uncategorized')
// //       })
// //     },
// //   })
// // }

// /*******************
//   tab機能1
// *******************/
// if (document.getElementById('tab')) {
//   //-- タブ切り替え --------------------------------------------------------------------
//   // 対象クラスのついているDOM全てを取得
//   var btn = document.getElementsByClassName('tab__btn');

//   // btn.length で 対象ボタンの個数全部を取得し、条件式が0になるまで回す。
//   // 要素indexは0から割り振られているので-1することで、個数を、indexに合わせる。
//   for (var i = btn.length - 1; i >= 0; i--) {
//     // 各ボタン、イベントリスナーでクリックしたら発動
//     btn[i].addEventListener('click', function () {

//       // btn.length で 対象ボタンの個数全部を取得し、条件式が0になるまで回す。
//       for (var x = btn.length - 1; x >= 0; x--) {
//         // contains で対象クラス有無をチェックし、あれば削除
//         if (btn[x].classList.contains('active')) {
//           btn[x].classList.remove('active');
//         }
//       }

//       // this はクリックされたオブジェクト。parentNode でその親。
//       // classList でクラス操作。active クラスの追加と削除。
//       this.classList.add('active');

//       // 対象クラスのついているDOM全てを取得
//       var box = document.getElementsByClassName('tab__container');
//       for (var y = box.length - 1; y >= 0; y--) {
//         // contains で対象クラス有無をチェックし、あれば削除
//         if (box[y].classList.contains('open')) {
//           box[y].classList.remove('open');
//         }
//       }

//       //data属性の値を取得して、同じidの要素にクラス付加。
//       var tab_id = this.getAttribute('data-tab');
//       document.getElementById(tab_id).classList.add('open');
//     });
//   }
// }

// /*******************
//   tab機能2
// *******************/
// window.addEventListener("load", function () {
//   // store tabs variable
//   var myTabs = document.querySelectorAll(".nav-tabs");
//   function myTabClicks(tabClickEvent) {
//     for (var i = 0; i < myTabs.length; i++) {
//       myTabs[i].classList.remove("active");
//     }
//     var clickedTab = tabClickEvent.currentTarget;
//     clickedTab.classList.add("active");
//     tabClickEvent.preventDefault();
//     var myContentPanes = document.querySelectorAll(".tab-content");
//     for (i = 0; i < myContentPanes.length; i++) {
//       myContentPanes[i].classList.remove("active");
//     }
//     var anchorReference = tabClickEvent.target;
//     var activePaneId = anchorReference.getAttribute("href");
//     var activePane = document.querySelector(activePaneId);
//     activePane.classList.add("active");
//   }

//   for (i = 0; i < myTabs.length; i++) {
//     myTabs[i].addEventListener("click", myTabClicks)
//   }
// });

// /*******************
//   見積もり機能
// *******************/
// if (document.getElementById('estimate')) {
//   const form = document.querySelectorAll('input[name=合計金額]')
//   const setu01 = document.querySelectorAll('input[name=メニュー01]')
//   const setu02 = document.querySelectorAll('input[name=オプション01]');
//   const radio = document.querySelectorAll("input[type='radio']")
//   console.log(radio)
//   for (i = 0; i < setu01.length; i++) {
//     setu01[i].addEventListener('click', function (e) {
//       price_sum();
//     });
//   }
//   //optionのクリックを監視
//   for (i = 0; i < setu02.length; i++) {
//     setu02[i].addEventListener('click', function (e) {
//       price_sum();
//     });
//   }
//   //合計計算
//   function price_sum() {
//     var sum = 0;
//     for (var i = 0; i < setu01.length; i++) {
//       if (setu01[i].checked) {
//         sum += parseInt(setu01[i].value);
//       }
//     }
//     for (var i = 0; i < setu02.length; i++) {
//       if (setu02[i].checked) {
//         sum += parseInt(setu02[i].value);
//       }
//     }
//     // console.log(form[0].value)
//     form[0].value = sum;
//   }
//   // for (let i = 0; i < setu01.length; i++) {
//   //   element.addEventListener('change',function(){})
//   //   const e = setu01[i];
//   //   e =
//   // }
// }

// /*******************
//   泡
// *******************/
// document.addEventListener('DOMContentLoaded', () => {
//   // コンテナを指定
//   const section = document.querySelector('.bubble-background');

//   // 泡を生成する関数
//   const createBubble = () => {
//     const bubbleEl = document.createElement('span');
//     bubbleEl.className = 'bubble';
//     const minSize = 10;
//     const maxSize = 50;
//     const size = Math.random() * (maxSize + 1 - minSize) + minSize;
//     bubbleEl.style.width = `${size}px`;
//     bubbleEl.style.height = `${size}px`;
//     bubbleEl.style.left = Math.random() * innerWidth + 'px';
//     section.appendChild(bubbleEl);

//     // 一定時間が経てば泡を消す
//     setTimeout(() => {
//       bubbleEl.remove();
//     }, 8000);
//   }

//   // 泡の生成を開始するトリガー（初期値はOFF）
//   let activeBubble = null;

//   // 泡の生成をストップする関数
//   const stopBubble = () => {
//     clearInterval(activeBubble);
//   };

//   // Intersection observerに渡すコールバック関数
//   const cb = (entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         activeBubble = setInterval(createBubble, 300);
//       } else {
//         stopBubble();
//       }
//     })
//   };

//   // Intersection observerに渡すオプション
//   const options = {
//     rootMargin: "100px 0px"
//   }

//   // Intersection observerの初期化
//   const io = new IntersectionObserver(cb, options);
//   io.POLL_INTERVAL = 100; // Polyfill
//   io.observe(section);
// });

// import "../scss/bootstrap5.custom.scss";
// import "../scss/style.scss";
